// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__PDzNU","bodyBackground":"styles_bodyBackground__7T03N"};